import React from 'react';
import { Link } from 'react-router-dom';
import { Donor } from '../../models/Donor';

type Props = {
  donor: Donor;
}

const SignupOrLogin = ({ donor }: Props) => {
  return (
    <>
      <h2 className="main_title"><span>{ donor.initialName } さんにメッセージを送る</span></h2>
      <strong>このドナーにメッセージを送るには、会員登録・ログインが必要です</strong>
      <ul className="btnarea">
        <li><Link to="/register" className="w_orangebtn">無料ではじめる</Link></li>
        <li><Link to="/login" className="w_orangebtn">ログイン</Link></li>
      </ul>
    </>
  );
}

export default SignupOrLogin;
